import React, { useEffect, useState } from "react";
import { Container, makeStyles, Box } from "@material-ui/core";
import Page from "src/components/Page";
import Toolbar from "./Toolbar";
import ProductList from "./ProductList";
import { useSelector, useDispatch } from "react-redux";
import { fetchAllProducts, clearEditDetails } from "./_product_Action";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: "100%",
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
}));

const Product = () => {
  const classes = useStyles();

  const [filterFn, setParentFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const dispatch = useDispatch();
  let allFetchData = useSelector((state) => state.product._allDetails) || [];

  useEffect(() => {
    //if (!allFetchData.length)
    dispatch(fetchAllProducts());

    dispatch(clearEditDetails());
    // eslint-disable-next-line
  }, []);

  let viewComponent;
  viewComponent = <ProductList TableData={allFetchData} filterFn={filterFn} />; //setParentPage={setParentPage} setParentLimit={setParentLimit} setReloadTable={setReloadTable} tableCount={allFetchData.length} />

  return (
    <Page className={classes.root} title="Product">
      <Container maxWidth={false}>
        <Toolbar setParentFilterFn={setParentFilterFn} />
        <Box mt={3}>{viewComponent}</Box>
      </Container>
    </Page>
  );
};

export default Product;
